import { GenericTryOrthomosaicsModal } from "./GenericTryOrthomosaicsModal"

export const TryOrthomosaicsModal = () => <GenericTryOrthomosaicsModal supportsBack />
